export const createOptions = (index, value) => ({
  id: index + value,
  optionsValue: value,
  title: value,
});

export const createCountryOptions = (paramsId, fullName) => ({
  id: paramsId,
  optionsValue: paramsId,
  title: `${fullName}`,
});

export const createDiscrepancyOptions = (paramsId, name) => ({
  id: paramsId,
  optionsValue: paramsId,
  title: name,
});

export const createClaimOptions = (paramsId, name) => ({
  id: paramsId,
  optionsValue: paramsId,
  title: name,
});

export const createClaimDaysOptions = days => ({
  id: days,
  optionsValue: days,
  title: days,
});
